import styled from "styled-components";
import { Text } from "./Text";

export const Welcome = styled(Text.Heading6)`
  text-transform: uppercase;
  font-weight: 700;
`;
